// extracted by mini-css-extract-plugin
export default {"ScrollInfiniteHits":"ScrollInfiniteHits--87a8de5","divButton":"divButton--fa2fe40"};